import axios from "axios";
import { format } from "date-fns";

const apiUrl = process.env.REACT_APP_API_URL;

export interface OrderDetailsDTO {
  orderNumber: string;
  customerName: string;
  guestNames?: string[]; // Optional field for guest names
  companyName?: string;
  bookingDescription?: string;
  bookingSmallNote?: string;
  businessCode?: string;
  businessUserId?: number;
  arrivalDate: string; 
  paymentIntentId: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phone: string;
  email: string;
  invoiceId?: number;
  isBusinessUser: boolean;
  totalPrice: number;
  invoiceURL?: string;
  invoiceAmount?: number;
  invoiceStatus?: string;
  createdAt?: string;
  filter: "all" | "private" | "business";

  bookings: BookingDetailsDTO[];
}

export interface BookingDetailsDTO {
  bookingId: number ;
  orderNumber: string;
  packageId: number;
  arrivalDate: string;
  departureDate: string;
  customerName: string;
  guestNames?: string[]; // Optional field for guest names
  companyName: string;
  businessCode: string;
  businessUserId?: number;
  privateUserId?: number;
  paymentIntentId: string;
  packageName?: string;
  mainImageUrl: string;
  pricingModelDescription?: string;
  totalPrice?: number;
  address: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phone: string;
  email: string;
  bookingType: string;
  isBusinessUser: boolean;
  privateUsers: PrivateUsersDTO[];
  transactions: TransactionDTO[];
  chalet?: ChaletDTO;
  bookingDescription?: string;
  bookingSmallNote?: string;
  totalCost: number;
  chaletId?: number;
  chaletType?: string;
  preBooking?: boolean;
  blockedChaletsCount?: number;
}

interface ChaletDTO {
  chaletId: number; // Correct the property name
  chaletType: number; // Update to number to handle numeric values
  isBlocked: boolean;
 // blockedDates: BlockedDateRangeDTO[];
}

export interface PrivateUsersDTO {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  comments?: string;
  sessionId?: string;
  paymentIntentId?: string;
}

export interface TransactionDTO {
  orderNumber: number;
  paymentIntentId: string;
  customerId: string;
  businessCode: string;
  sessionId: string;
  amount: number;
  description: string;
  status: string;
  createdAt: string;
  privateUserId: number;
  businessUserId: number;
  receiptUrl: string;
}

export interface ServiceResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const checkAvailability = async (dateRange: { startDate: Date | null, endDate: Date | null }, packageId?: number) => {
  if (dateRange.startDate && dateRange.endDate) {
      const now = new Date();
      if (dateRange.startDate < now || dateRange.endDate < now) {
          throw new Error('Please select future dates.');
      }

      const formattedArrivalDate = format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ssXXX");
      const formattedDepartureDate = format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ssXXX");

    

      const params: { arrivalDate: string; departureDate: string; packageId?: number } = {
          arrivalDate: formattedArrivalDate,
          departureDate: formattedDepartureDate,
      };

      if (packageId !== undefined && packageId !== null) {
          params.packageId = packageId;
      }

      const response = await axios.get<{ data: any }>(`${process.env.REACT_APP_API_URL}/Booking/availability`, { params });
      return response.data.data; // Access the nested data field
  }
  throw new Error('Invalid date range.');
};

export const getAllBookingsWithDetails = async (): Promise<
  ServiceResponse<OrderDetailsDTO[]>
> => {
  try {
    const response = await axios.get<ServiceResponse<OrderDetailsDTO[]>>(
      `${apiUrl}/Booking/getAllBookingsWithDetails`,
      {
        params: { _t: Date.now() },
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      }
    );
    console.log("Response data:", response.data);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error fetching bookings: ${error.message}`);
  }
};

export const getBookingsByOrderNumber = async (
  orderNumber: string
): Promise<ServiceResponse<BookingDetailsDTO[]>> => {
  try {
    const response = await axios.get<ServiceResponse<BookingDetailsDTO[]>>(
      `${apiUrl}/bookings/details/${orderNumber}`
    );
    console.log('getBookingsByOrderNumber response:', response.data);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error fetching bookings: ${error.message}`);
  }
};

export const sendInvoice = async (
  orderNumber: string,
  customerEmail: string,
  sendAsPdf: boolean
): Promise<ServiceResponse<string>> => {
  try {
    const response = await axios.post<ServiceResponse<string>>(
      `${apiUrl}/bookings/invoies/send`,
      { orderNumber, customerEmail, sendAsPdf }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(`Error sending invoice: ${error.message}`);
  }
};

export const getBookingDetails = async (orderNumber: string) => {
  const response = await axios.get(`${apiUrl}/PackageBooking/bookingsByorderNumber${orderNumber}`);
  return response.data;
};
